//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: 'StepperNavItem',
    inject: ['currentStepIndex'],
    props: {
        index: {
            type: Number,
            required: true,
        },
        label: {
            type: String,
            required: true,
        },
        route: {
            type: String,
            required: true,
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    computed: {
        isActive() {
            return this.currentStepIndex === this.index;
        },
        isDisabled() {
            return this.disabled || !this.$user || !this.$user.first_name;
        },
    },
    methods: {
        handleClick() {
            if (!this.isDisabled) {
                this.$router.push(this.localePath(this.route));
            }
        },
    },
};
